import React from 'react';
import PropTypes from 'prop-types';
import { DateTimePicker } from '@material-ui/pickers';

const FormDateTimeField = ({
  input,
  label,
  meta: { touched, error },
  minDate,
  style
}) => (
    <DateTimePicker
      label={label}
      ampm={false}
      error={touched && error ? true : false}
      helperText={touched && error}
      margin="dense"
      minDate={minDate}
      InputLabelProps={{
        shrink: true,
      }}
      autoOk
      okLabel="OK"
      cancelLabel="Anuluj"
      clearLabel="Wyczyść"
      invalidLabel="Wybierz ..."
      onChange={value => input.onChange(value)}
      format="DD.MM.YYYY HH:mm:ss"
      value={input.value ? input.value : null}
      style={style}
      clearable
    />
  );

FormDateTimeField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  minDate: PropTypes.object,
  style: PropTypes.object,
};

export default FormDateTimeField;
